import { bool, string } from 'prop-types';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import MuteImg from 'Assets/images/pages/web-chat/muted.svg';
import LowNetworkImg from 'Assets/images/pages/web-chat/low-network.svg';

import css from './MemberNameMinimized.less';

function MemberNameMinimized({ name, isMuted, isLowNetwork }) {
  return (
    <div className={css.container}>
      <div className={css.name}>{name}</div>
      {isMuted && (
        <Popup
          content={`${name}’s microphone is off`}
          position="top center"
          popper={{ id: 'video-header-container', style: { zIndex: 200000 } }}
          trigger={
            <div className={css.muted}>
              <img src={MuteImg} alt="Mute" />
            </div>
          }
        />
      )}
      {isLowNetwork && (
        <Popup
          content={`${name}’s internet connection is unstable`}
          position="top center"
          popper={{ id: 'video-header-container', style: { zIndex: 200000 } }}
          trigger={
            <div className={css.muted}>
              <img src={LowNetworkImg} alt="low" />
            </div>
          }
        />
      )}
    </div>
  );
}

MemberNameMinimized.propTypes = {
  name: string,
  isMuted: bool,
  isLowNetwork: bool,
};

MemberNameMinimized.defaultProps = {
  name: '',
  isMuted: false,
  isLowNetwork: false,
};

export default MemberNameMinimized;
